import type { TabularRunState } from "../../viewer/storage/runState.ts";
import TabularContainer from "./preview/TabularContainer";
import TabularViewer from "./preview/TabularViewer";

interface Props {
  runState: TabularRunState;
}

export default function TabularViewerContainer({ runState }: Props) {
  return (
    <TabularContainer>
      <TabularViewer runState={runState} />
    </TabularContainer>
  );
}
